
export enum GoalLevelCd {
	DISTRICT = 'District',
	LANE = 'Lane',
	REGION = 'Region',
	SIC = 'SIC'}

